import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, consoleLog, convertStringToArray, convertStringToArrayForRadio, electOwningCase } from '../../utils';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../restClient';
// children
import {
  DOCUMENTATION_DRAFT,
  INITAL_REQUEST_DATA_READY,
  INITIAL_REQUEST_INCOMPLETE
} from '../../constants';
import CaseBodyFooter from '../common/CaseBodyFooter';
import CaseMenu from '../common/CaseMenu/CaseMenu';
import Panel from '../common/Tabs/Panel';
import Tabs from '../common/Tabs/Tabs';
import Activation from './Activation';
import CustomerDetails from './CustomerDetails';
import Documentation from './Documentation';
import {
  AddOwnerModal,
  CancelCaseModal,
  DraftGenerationSucessModal,
  GenerateBgProcessModal,
  SendToClientModal,
  ShareCaseConfirmation,
  SubmitRequestModal
} from './Modals';
import ProductRequests from './ProductRequests';
// feature flags utils
import { isTbtEnabled, isTbtForceGDocsEnabled } from '../../featureFlags';
// actionCreator
import { blockUi, resetStore, unBlockUi } from '../../actions/actionCreator';
import { caseMenuInfo, resetCaseMenuInfo } from '../common/CaseMenu/actions/actionCreator';
import { setCases } from '../createAcase/actions/actionCreator';
import { setDarkTitleBarContent } from '../layouts/actions/actionCreator';
import { enableTab, hidePreviewAndGenerateDocBtns, setCaseOwner, setCurrentActiveTab, setGenrateDoc, showPreviewAndGenerateDocBtns } from './actions/actionCreator';
// styles
import './styles.css';

class Casebody extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSubmitRequestModalDialog: false,
      caseIdsForDraftGeneration: [],
      showCancelCaseModalDialog: false,
      openSendToClientModalDialog: false,
      openSendToClientModalConfirmationDialog: false,
      openAddOwnerModalConfirmationDialog: false,
      showDraftGenerationSuccessModal: false,
      showGenerateBgProcessModal: false,
      casesToBeCancelled: {},
      sentToClient: {},
      checkedvlaue: false,
      minNoOfCasesSelected: false,
      minNoOfClientCasesSelected: undefined,
      resetStateVals: undefined,
      cancelReasonListed: false,
      checkedOptionvalue: false,
      cancelReason: '',
      displayUserData: [],
      _displaySelectedUser: '',
      selectAllFlag: false,
      forceGDocsPath: false,
      showUserPathSelection: false,
      caseBuildActions: [],
      isTbtFlow: false
    };
    this.payLoad = {};
    this.caseId = [];
    this.lang = {}
  }

  fireFooterBtnRules = (props) => {
    if (props.activeTabId > 1) {
      props.hidePreviewAndGenerateDocBtns();
    } else {
      props.showPreviewAndGenerateDocBtns();
    }
  }

  componentDidMount() {
    /* ========== Customer Details Page JSON ========== */
    aemHostClient("/aemData/formData/json_customer-details")
      .then(({ data }) => {
        this.setState({ pageJson: data.par })

        return aemHostClient("/aemData/formData/json_product-requests")
      })
      /* ========== Product request modal page json ========== */

      .then(({ data }) => {
        this.setState({ productRequestJson: data.par })

        return aemHostClient("/aemData/formData/json_documentation-confirmation")
      })
      /* ========== Documentation confirmation modal page json ========== */

      .then(({ data }) => {
        this.setState({ documentationConfirmationJson: data.par })

        return aemHostClient("/aemData/formData/json_documentation")
      })
      /* ========== Documentation page json ========== */

      .then(({ data }) => {
        this.setState({ documentationJson: data.par })

        return aemHostClient("/aemData/formData/json_cancel-case")
      })

      /* ========== Dark title bar page json ========== */
      // aemHostClient("/aemData/formData/json_dark-title-bar")
      // .then(({data}) => {
      //     this.setState({darkTitleBarJson: data.par});
      //      document.title = data.par.static_text_darkTitleBar.activation
      // });

      /* ========== Cancel Case popup page json ========== */

      .then(({ data }) => {
        this.setState({ cancelCaseModalPageJson: data });

        return aemHostClient("/aemData/formData/json_invite-others-to-collaborate")
      })
      /* ========== Send Invite popup page json ========== */

      .then(({ data }) => {
        this.setState({ formJsonClientToSend: data });

        return aemHostClient("/aemData/formData/json_your-invite-was-sent")
      })
      /* ========== Invite Sent popup page json ========== */

      .then(({ data }) => {
        this.setState({ formJsonInviteSent: data });

        return aemHostClient("/aemData/formData/json_add-owner-page")
      })
      /* ========== Add Owner Form JSON ========== */

      .then(({ data }) => {
        this.setState({ formJsonAddOwner: data });

        return aemHostClient("/aemData/formData/json_ach-payment-type-selection")
      })
      /* ========== ACH Payment Type Subgroup Modal JSON ========== */

      .then(({ data }) => {
        this.setState({ achPaymentTypeModalJson: data });
      })

    let heading;
    let transaltedText;
    window.sessionStorage.setItem('casesForRefresh', this.props.cases);
    window.localStorage.setItem('owningCase', this.props.owningCase.caseId);
    let isItem = window.sessionStorage.getItem("isItem");
    if (isItem !== null) {
      window.sessionStorage.removeItem("isItem");
    }
    aemHostClient("/aemData/formData/json_dark-title-bar")
      .then(({ data, status }) => {

        if (Object.keys(this.props.cases).length >= 1) {
          const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
          heading = `${this.props.owningCase.entityName} ${Object.keys(this.props.cases).length > 1 ? `${'('}${'+'}${noOfCasesExcludingRoot} ${Translations(data.par.static_text_darkTitleBar.others, this.props.lang.currentLang.lang, this.props.lang.translatedData)}${')'}` : ''}`;
        } else {
          heading = `${this.props.owningCase.entityName}`;
        }

        transaltedText = Translations(data.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang, this.props.lang.translatedData);
        taxonomyHostClient(Translations(data.par.static_text_darkTitleBar.CaseStatusapi, this.props.lang.currentLang.lang, this.props.lang.translatedData))
          .then(({ data }) => {
            this.props.setDarkTitleBarContent(heading, true, transaltedText, "icon icon-delete", this.props.owningCase, data.responseData.classificationNodes[0].associations);
          })
      });
    this.fireFooterBtnRules(this.props);

    if (Object.keys(this.props.cases).length === 1) {
      this.setState({ minNoOfCasesSelected: true });
    }

    setTimeout(() => {
      eapiClient('/cases/' + this.props.owningCase.caseId + '/case-owner')
        .then(({ data }) => {
          this.props.setCaseOwner(data.responseData);
          this.setState({
            ...this.state,
            displayUserData: data.responseData
          })
        });
    }, 1000)

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeTabId !== this.props.activeTabId) {
      this.fireFooterBtnRules(nextProps);
      eapiClient('/cases/' + this.props.owningCase.caseId + '/menu')
        .then(({ data }) => {
          //this.setState({RefreshData :data.responseData })
          this.props.caseMenuInfo(data.responseData)
        });
    }
    if (Object.keys(nextProps.cases).length === 1) {
      this.setState({ minNoOfCasesSelected: true });
    }
    if (this.props.lang !== nextProps.lang) {
      let heading;
      let transaltedText;

      aemHostClient("/aemData/formData/json_dark-title-bar")
        .then(({ data, status }) => {

          if (Object.keys(this.props.cases).length >= 1) {
            const noOfCasesExcludingRoot = Object.keys(this.props.cases).length - 1;
            heading = `${this.props.owningCase.entityName} ${Object.keys(this.props.cases).length > 1 ? `${'('}${'+'}${noOfCasesExcludingRoot} ${Translations(data.par.static_text_darkTitleBar.others, this.props.lang.currentLang.lang, this.props.lang.translatedData)}${')'}` : ''}`;
          } else {
            heading = `${this.props.owningCase.entityName}`;
          }

          transaltedText = Translations(data.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang, this.props.lang.translatedData);
          taxonomyHostClient(Translations(data.par.static_text_darkTitleBar.CaseStatusapi, this.props.lang.currentLang.lang, this.props.lang.translatedData))
            .then(({ data }) => {
              this.props.setDarkTitleBarContent(heading, true, transaltedText, "icon icon-delete", this.props.owningCase, data.responseData.classificationNodes[0].associations);
            })
        });
    }
  }

  toggleDialog = (cb) => {
    cb !== undefined && typeof (cb) === "string" ? document.getElementById(cb).focus() : '';
    this.setState({
      openSendToClientModalDialog: false,
      showSubmitRequestModalDialog: false,
      showDraftGenerationSuccessModal: false,
      openSendToClientModalConfirmationDialog: false,
      openAddOwnerModalDialog: false,
      displaySelectedUser: '',
      userRoll: '',
      resetStateVals: true,
      sentToClient: {},
      caseIdsForDraftGeneration: [],
      minNoOfClientCasesSelected: undefined,
      forceGDocsPath: false
    }, () => {
      if (cb && typeof (cb) === "function") {
        cb();
      }
    });
  }

  toggleCancelCaseDialog = () => {
    this.setState({
      showCancelCaseModalDialog: false,
      casesToBeCancelled: {},
      minNoOfCasesSelected: false,
      cancelReasonListed: false
    });
  }

  /*Cancel Case Modal Callbacks*/
  _onCancelCase = () => {
    var apiUrl = this.state.cancelCaseModalPageJson.par.modal_cancelCase.apiUrl;
    var casesToBeCancelled = Object.keys(this.state.casesToBeCancelled)
      .reduce((acc, cId) => {
        if (this.state.casesToBeCancelled[cId]) {
          acc.push(cId);
        }
        return acc;
      }, []);
    if (Object.keys(this.props.cases).length === 1) {
      casesToBeCancelled = [Object.keys(this.props.cases)[0]];
    }
    this.payLoad.cancelReason = this.state.cancelReason;
    this.payLoad.caseIds = casesToBeCancelled;
    this.props.blockUi();
    eapiClient(apiUrl, {
      method: 'PUT',
      data: JSON.stringify(this.payLoad)
    })
      .then(({ data }) => {
        for (var i = 0; i < casesToBeCancelled.length; i++) {
          Object.keys(this.props.cases).map((caseId, index) => {
            if (this.props.cases[caseId].id === casesToBeCancelled[i]) {
              if (this.props.cases[caseId].eSignStatus && this.props.cases[caseId].eSignStatus !== null && this.props.cases[caseId].eSignStatus.overallStatus === 'in-progress') {
                eapiClient(`/cases/esign/${casesToBeCancelled[i]}/cancelSignatory/GB`, {
                  method: 'POST',
                  timeout: 100000
                }).then(({ data, status }) => { })
              }
            }
          })
        }
        this.setState({ showCancelCaseModalDialog: false }, () => {
          this.lang = this.props.lang;
          this.props.resetStore(this.lang);
          this.props.history.push('/case-list');
        })
        this.props.unBlockUi();
      });
  }

  openCancelCaseModalDialog = () => {
    eapiClient('/cases/' + this.props.owningCase.caseId + '/allcases?status=false', { timeout: 420000 })
      .then(({ data, status }) => {
        this.props.setCases(data.responseData);
        this.setState({ showCancelCaseModalDialog: true });
        this.setState({ cancelReason: '' });
        this.setState({ isDisable: true });
      })
  }

  casesSelectedForCancellation = (casesToBeCancelled) => {
    return Object.keys(casesToBeCancelled).some(c => casesToBeCancelled[c]);
  }

  casesSelectedForSentToClient = (casesToBeCancelled) => {
    return Object.keys(casesToBeCancelled).some(c => casesToBeCancelled[c]);
  }

  checkboxStatus = (event) => {
    if (event.target.checked === true && (this.state.cancelReason !== '' || this.state.cancelReason !== undefined)) {
      this.setState({ cancelReasonListed: true, minNoOfCasesSelected: true });
    } else {
      this.setState({ cancelReasonListed: false });
    }
  }

  checkedOptions = (event) => {
    var casesToBeCancelled = { ...this.state.casesToBeCancelled };
    if (event.target.checked) {
      casesToBeCancelled[event.target.name.split("-").pop()] = true;
    } else {
      casesToBeCancelled[event.target.name.split("-").pop()] = false;
    }
    var minNoOfCasesSelected = this.casesSelectedForCancellation(casesToBeCancelled);
    this.setState({ casesToBeCancelled, minNoOfCasesSelected });
  }

  sentToClientCheckedOptions = (event) => {
    var sentToClient = { ...this.state.sentToClient };
    if (event.target.checked) {
      sentToClient[event.target.name.split("-").pop()] = true;
    } else {
      sentToClient[event.target.name.split("-").pop()] = false;
    }
    var minNoOfClientCasesSelected = this.casesSelectedForSentToClient(sentToClient);
    this.setState({
      sentToClient,
      minNoOfClientCasesSelected,
      resetStateVals: false
    });
  }

  setRadioSelection = (value, name) => {
    this.setState({ cancelReason: value });
  }

  /*Send to client Modal Callbacks*/
  openSendToClientModalDialog = () => {
    this.setState({ openSendToClientModalDialog: true });
  }

  openAddOwnerModalDialog = () => {
    this.setState({ openAddOwnerModalDialog: true })
  }

  getFormDataClientToSend = (formData) => {
    this.setState({ formData });
  }

  getSelectedUser = (selectedUser) => {
    if (!this.state.displayUserData.find(item => selectedUser.id === item.id)) {
      this.setState({
        ...this.state,
        displaySelectedUser: selectedUser.name,
        selectedUser: selectedUser
      })
      //this.setState({displayUserData: this.state.displayUserData.concat([selectedUser]).reverse()});
    }
  }

  setOwnerRoll = (value) => {
    this.setState({
      ...this.state,
      userRoll: value
    })
  }

  submitOwner = () => {
    let payload = new OwnerListData(this.state);
    payload.ownerPayLoad(this.state);
    payload.data.status = "urn:hsbc:cmb:gdocs:case:taxonomies:status:active"
    const apiURL = "/cases/" + this.props.owningCase.caseId + "/case-owner";
    eapiClient(apiURL, {
      method: 'PUT',
      data: JSON.stringify(payload.data)
    })
      .then(({ data }) => {
        this.props.setCaseOwner(data.responseData);
        this.setState({
          ...this.state,
          displayUserData: data.responseData,
          displaySelectedUser: '',
          userRoll: '',
          openAddOwnerModalDialog: false
        })
        eapiClient('/cases/' + this.props.owningCase.caseId + '/menu')
          .then(({ data }) => {
            this.props.caseMenuInfo(data.responseData)
          });
      })

  }

  deleteAddedOwner = (event) => {
    let filterData = this.state.displayUserData.filter(item => item.email === event.target.getAttribute('data-key'))
    let payload = new OwnerListData(filterData[0]);
    payload.ownerDelteedPayLoad(filterData[0]);
    payload.deleteData.status = "urn:hsbc:cmb:gdocs:case:taxonomies:status:delete"
    const apiURL = "/cases/" + this.props.owningCase.caseId + "/case-owner";
    eapiClient(apiURL, {
      method: 'PUT',
      data: JSON.stringify(payload.deleteData)
    })
      .then(({ data }) => {
        this.props.setCaseOwner(data.responseData);
        this.setState({
          ...this.state,
          displayUserData: data.responseData
        })
        eapiClient('/cases/' + this.props.owningCase.caseId + '/menu')
          .then(({ data }) => {
            this.props.caseMenuInfo(data.responseData)
          });
      })
  }

  onFormSubmitClientToSend = (data) => {
    var payLoad = {};
    payLoad.firstName = data.firstName
    payLoad.lastname = data.lastName
    payLoad.email = data.email
    payLoad.language = { name: data.language, value: data.language }

    if (this.state.sentToClient !== undefined) {
      var casesSendToClient = Object.keys(this.state.sentToClient)
        .reduce((acc, cId) => {
          if (this.state.sentToClient[cId]) {
            acc.push(cId);
          }
          return acc;
        }, []);

      if (Object.keys(this.props.cases).length === 1) {
        casesSendToClient = [Object.keys(this.props.cases)[0]];
      }
      payLoad.caseIds = casesSendToClient
    } else {
      payLoad.caseIds = Object.keys(this.props.cases);
    }
    //payLoad.caseIds = Object.keys(this.props.cases);
    //payLoad.language = {name:'Eng', value:'Eng'}
    //return false;
    if (casesSendToClient.length === 0) {
      this.setState({ minNoOfClientCasesSelected: false });
    }
    if (data.firstName !== "" && data.lastName !== "" && data.email !== "" && data.language !== "" && casesSendToClient.length > 0) {
      eapiClient("/cases/shareCase", {
        method: 'POST',
        timeout: 30000,
        data: JSON.stringify(payLoad)
      })
        .then(({ data, status, headers }) => {
          this.toggleDialog()
          eapiClient('/cases/' + this.props.owningCase.caseId + '/menu')
            .then(({ data }) => {
              //this.setState({RefreshData :data.responseData })
              this.props.caseMenuInfo(data.responseData)
            });
          if (status === 200) {
            //const token = headers["x-auth-token"];
            this.setState({ openSendToClientModalConfirmationDialog: true });
            //const {userDetails, lastLogin} = data.responseData;
            //this.props.logInUser(true, token,  data.responseData.principal, new Date(), '/case-list');
            //this.props.history.push(this.state.from || '/case-list');
          }
        })
        .catch((error) => {
          if (error && error.response && error.response.status === 401) {
            this.setState({ showUnAuthorised: true });
          }
        });
    } else {
      //alert("please fill all mandatory fields");
    }
  }

  onFormCancelClientToSend = () => {
    this.toggleDialog();
  }

  /* Generate GDocs Draft Documentation - Foreground Process Case Modal Callbacks */
  generateDraftDocumentation = (caseIds) => {
    return new Promise((resolve, reject) => {
      eapiClient("/pdfGeneration/generate-gdocs-documentation?isBgProcess=false", {
        method: 'POST',
        timeout: 100000,
        data: JSON.stringify({ caseIds, documentationPath: 'GDOCS' })
      })
        .then(() => {
          this.cancelDocStatusPoll = setInterval(() => {
            eapiClient('/cases/poll-generate-gdocs-draft', {
              noBlocking: true,
              method: 'POST',
              data: JSON.stringify({ caseIds })
            })
              .then(({ status }) => {
                if (status === 201) {
                  clearInterval(this.cancelDocStatusPoll);
                  resolve();
                }
              })
              .catch((error) => {
                clearInterval(this.cancelDocStatusPoll);
                reject(error);
              });
          }, 5000);
        })
        .catch(reject);
    });
  }

  /* Generate GDocs Draft Documentation - Background Process */
  generateDraftDocumentationBgProcess = (caseIds) => {
    return eapiClient("/pdfGeneration/generate-gdocs-documentation?isBgProcess=true", {
      method: 'POST',
      timeout: 100000,
      data: JSON.stringify({ caseIds, documentationPath: 'GDOCS' })
    });
  }

  /* Generate TBT Draft Documentation - Foreground Process */
  generateTbtDraftDocumentation = (caseIds) => {
    return new Promise((resolve, reject) => {
      eapiClient("/pdfGeneration/generate-tbt-documentation?isBgProcess=false", {
        method: 'POST',
        timeout: 100000,
        data: JSON.stringify({ caseIds, documentationPath: 'TBT' })
      })
        .then(() => {
          this.cancelTbtDocStatusPoll = setInterval(() => {
            eapiClient('/cases/poll-generate-tbt-draft', {
              noBlocking: true,
              method: 'POST',
              data: JSON.stringify({ caseIds })
            })
              .then(({ status }) => {
                if (status === 201) {
                  clearInterval(this.cancelTbtDocStatusPoll);
                  resolve();
                }
              })
              .catch((error) => {
                clearInterval(this.cancelTbtDocStatusPoll);
                reject(error);
              });
          }, 5000);
        })
        .catch(reject);
    });
  }

  /* Generate TBT Draft Documentation - Background Process */
  generateTbtDraftDocumentationBgProcess = (caseIds) => {
    return eapiClient("/pdfGeneration/generate-tbt-documentation?isBgProcess=true", {
      method: 'POST',
      timeout: 100000,
      data: JSON.stringify({ caseIds, documentationPath: 'TBT' })
    });
  }

  openSubmitRequestModalDialog = () => {
    this.setState({
      selectAllFlag: false,
      showUserPathSelection: false,
      caseBuildActions: []
    });
    eapiClient('/cases/' + this.props.owningCase.caseId + '/products/generate-doc/')
      .then(({ data }) => {
        //this.setState({RefreshData :data.responseData })
        this.props.setGenrateDoc(data.responseData);
        if (this.props.isTbtEnabled === true) {
          eapiClient('/channel-enablement/tbt/compute-build-action', {
            method: 'POST',
            timeout: 420000,
            headers: { 'X-Debug-Diagnostics': 'payload' },
            data: JSON.stringify({ caseId: this.props.owningCase.caseId })
          })
            .then(({ data, status }) => {
              if (status === 200) {
                this.setState({
                  showUserPathSelection: data.responseData.showUserPathSelection,
                  caseBuildActions: data.responseData.caseBuildActions || [],
                  showSubmitRequestModalDialog: true
                });
              }
            })
            .catch((error) => {
              console.error(error);
              consoleLog('Error in fetching compute-build-action data', 'error', false, error);
              if (error.response && (error.response.status === 400 || error.response.status === 422)) {
                this.setState({ showSubmitRequestModalDialog: true });
              }
            });
        } else {
          this.setState({ showSubmitRequestModalDialog: true });
        }
      })
      .catch((error) => {
        consoleLog('Error in fetching generate-doc data', 'error', false, error);
      });
  };

  _caseSelectedForDraftSingleEntity = (caseId) => {
    if (!this.state.caseIdsForDraftGeneration.includes(caseId)) {
      this.setState({ caseIdsForDraftGeneration: [...this.state.caseIdsForDraftGeneration, caseId] });
    }
  }

  _caseSelectedForDraftMultiEntity = (event) => {
    if (this.state.selectAllFlag && !event.target.checked) {
      let caseIdsForDraftGeneration = [...this.state.caseIdsForDraftGeneration];
      caseIdsForDraftGeneration.remove(event.target.name);
      this.setState({ caseIdsForDraftGeneration });
      this.setState({ selectAllFlag: false });
    } else {
      let caseIdsForDraftGeneration = [...this.state.caseIdsForDraftGeneration];
      if (event.target.checked && !caseIdsForDraftGeneration.includes(event.target.name)) {
        caseIdsForDraftGeneration.push(event.target.name);
      } else {
        caseIdsForDraftGeneration.remove(event.target.name);
      }
      this.setState({ caseIdsForDraftGeneration });
    }
  }

  _selectAllCaseSelectedForDraftMultiEntity = (event) => {
    const caseIds = this.props.sow ? '' : Object.keys(this.props.cases);
    let caseIdsForDraftGeneration = [...this.state.caseIdsForDraftGeneration];
    if (event.target.checked) {
      caseIdsForDraftGeneration = caseIds.filter(caseId => {
        return (this.props.cases[caseId].status === INITAL_REQUEST_DATA_READY || this.props.cases[caseId].status === DOCUMENTATION_DRAFT || ((this.props.generateDoc[caseId] !== undefined && Object.keys(this.props.generateDoc).length > 0 ? this.props.generateDoc[caseId].generateDoc : '') && this.props.cases[caseId].status === INITIAL_REQUEST_INCOMPLETE))
      })
      this.setState({ selectAllFlag: true })
    } else {
      caseIdsForDraftGeneration = []
      this.setState({ selectAllFlag: false })
    }
    this.setState({ caseIdsForDraftGeneration });
  }

  /* Splits the selected case ids into TBT and GDOCS groups based on per-entity/case build actions */
  segregateSelectedCaseIdsByBuildAction = (selectedCaseIds) => {
    const { showUserPathSelection, forceGDocsPath, caseBuildActions } = this.state;

    // User explicitly forced everything through GDocs terms and conditions
    if (showUserPathSelection === true && forceGDocsPath === true) {
      return { tbtCaseIds: [], gdocsCaseIds: [...selectedCaseIds] };
    }

    const buildActionByCaseId = caseBuildActions.reduce((acc, item) => {
      acc[item.caseId] = item.buildAction;
      return acc;
    }, {});

    const tbtCaseIds = [];
    const gdocsCaseIds = [];

    selectedCaseIds.forEach((caseId) => {
      if (buildActionByCaseId[caseId] === 'TBT') {
        tbtCaseIds.push(caseId);
      } else {
        gdocsCaseIds.push(caseId);   // default/fallback stays GDOCS
      }
    });

    return { tbtCaseIds, gdocsCaseIds };
  }

  _onGenerateDraftClick = () => {
    const selectedCaseIds = [...this.state.caseIdsForDraftGeneration];
    const { tbtCaseIds, gdocsCaseIds } = this.segregateSelectedCaseIdsByBuildAction(selectedCaseIds);

    this.toggleDialog();
    this.props.blockUi();
    this.setState({
      caseIdsForDraftGeneration: [],
      isTbtFlow: tbtCaseIds.length > 0
    })

    const casesArray = selectedCaseIds.map(caseId => this.props.generateDoc[caseId]);
    const glsProductsArray = casesArray.reduce((acc, caseDetail) => {
      const glsProduct = caseDetail && caseDetail.productDatas && caseDetail.productDatas.find(data => data.name === 'GLS');
      if (glsProduct) {
        acc.push(glsProduct);
      }
      return acc;
    }, []);

    const hasGlsAndMultipleCases = glsProductsArray.length > 0 && selectedCaseIds.length > 1;
    const bgProcessThreshold = hasGlsAndMultipleCases ? 10 : 15;
    const shouldRunInBackground = Object.values(this.props.generateDoc).length > 0 && selectedCaseIds.length >= bgProcessThreshold;

    const generationTasks = [];

    if (tbtCaseIds.length > 0) {
      generationTasks.push(
        shouldRunInBackground
          ? this.generateTbtDraftDocumentationBgProcess(tbtCaseIds)
          : this.generateTbtDraftDocumentation(tbtCaseIds)
      );
    }

    if (gdocsCaseIds.length > 0) {
      generationTasks.push(
        shouldRunInBackground
          ? this.generateDraftDocumentationBgProcess(gdocsCaseIds)
          : this.generateDraftDocumentation(gdocsCaseIds)
      );
    }

    if (generationTasks.length === 0) {
      this.props.unBlockUi();
      return;
    }

    Promise.all(generationTasks)
      .then(() => {
        this.props.unBlockUi();
        if (shouldRunInBackground) {
          this.setState({ showGenerateBgProcessModal: true });
        } else {
          this.setState({ showDraftGenerationSuccessModal: true });
        }
      })
      .catch((error) => {
        this.props.unBlockUi();
        consoleLog('Error in draft documentation generation', 'error', false, error);
      });
  }

  _onOk = () => {
    this.props.enableTab("documentationTab");
    this.props.setCurrentActiveTab(2);
    eapiClient('/cases/' + this.props.owningCase.caseId + '/menu')
      .then(({ data }) => {
        this.props.caseMenuInfo(data.responseData)
      });
    this.toggleDialog();
  }

  redirectTopage = () => {
    this.props.history.push("/case-body/preview-request/")
  }

  redirectToCaseList = () => {
    this.setState({ showGenerateBgProcessModal: false });
    this.props.history.push('/case-list');
  }

  handlePathSelectionRadioOnChange = (value, name) => {
    this.setState({ forceGDocsPath: value });
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  render() {
    let caseBodyJsx;
    if (this.state.pageJson === undefined || this.state.cancelCaseModalPageJson === undefined || this.state.documentationConfirmationJson === undefined || this.state.formJsonAddOwner === undefined || this.state.formJsonInviteSent === undefined || this.state.formJsonClientToSend === undefined || this.state.productRequestJson === undefined || this.state.achPaymentTypeModalJson === undefined) {
      caseBodyJsx = (<h3>Loading...</h3>);
    } else {
      caseBodyJsx = (
        <div className="case-body-main-container">
          <div className="left-case-body-container">
            <Tabs
              selected={this.props.tabs.activeTabId}
              useReduxHandler={true}
              setCurrentActiveTab={this.props.setCurrentActiveTab}
              ariaSelected={this.props.tabs.activeTabId}
            >
              <Panel
                label={this.translateWord(this.state.pageJson.tab_pageTab.text)[0]}
                status={this.props.tabs.customerDetailsTab.isComplete}
                disabled={this.props.tabs.customerDetailsTab.disabled}
              >
                <CustomerDetails
                  history={this.props.history}
                  customerPageJson={this.state.pageJson}
                />
              </Panel>
              <Panel
                label={this.translateWord(this.state.pageJson.tab_pageTab.text)[1]}
                status={this.props.tabs.productRequestsTab.isComplete}
                disabled={this.props.tabs.productRequestsTab.disabled}
              >
                <div>
                  <ProductRequests
                    history={this.props.history}
                    productRequestJson={this.state.productRequestJson}
                    achPaymentTypeModalJson={this.state.achPaymentTypeModalJson}
                    language={this.props.lang}
                  />
                </div>
              </Panel>
              <Panel
                label={this.translateWord(this.state.pageJson.tab_pageTab.text)[2]}
                status={this.props.tabs.documentationTab.isComplete}
                disabled={this.props.tabs.documentationTab.disabled}
              >
                <Documentation history={this.props.history} />
              </Panel>
              <Panel
                label={this.translateWord(this.state.pageJson.tab_pageTab.text)[3]}
                status={this.props.tabs.activationTab.isComplete}
                disabled={this.props.tabs.activationTab.disabled}
              >
                <Activation history={this.props.history} />
              </Panel>
            </Tabs>
            <div className="right-case-body-container">
              <CaseMenu
                history={this.props.history}
                caseId={this.props.owningCase && this.props.owningCase.caseId}
                _getData={this.state.RefreshData}
                lang={this.props.lang}
              />
            </div>
          </div>

          <CaseBodyFooter bsClass="case-body-footer-container">
            <div className='case-body-footer-flex-container'>
              <div className='case-body-footer'>
                {!this.props.customer && (
                  <button
                    className="gdocs-btn-default cancel"
                    id="cancel_case"
                    onClick={this.openCancelCaseModalDialog}
                    disabled={this.props.footerBtnsStatus.cancelBtn.disabled}
                  >
                    {Translations(this.state.pageJson.button_cancelCase.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  </button>
                )}
                {!this.props.customer
                  ? <button
                    className="gdocs-btn-default btn-li"
                    onClick={this.openSendToClientModalDialog}
                    id="_shareCase"
                    tabIndex="0"
                    disabled={this.props.footerBtnsStatus.sendToClientBtn.disabled}
                  >
                    <div className="gdocs-btn-with-icon_flex">
                      <span className="icon icon-message gdocs-valign-bottom fontsize24 gdocs-pright-10"></span>
                      {Translations(this.state.pageJson.button_shareCase.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                    </div>
                  </button>
                  : <button
                    className="gdocs-btn-default btn-li"
                    onClick={this.openSendToClientModalDialog}
                    id="_shareCase"
                    tabIndex="0"
                    disabled={this.props.footerBtnsStatus.shareCase.disabled}
                  >
                    <div className="gdocs-btn-with-icon_flex">
                      <span className="icon icon-message gdocs-valign-bottom fontsize24 gdocs-pright-10"></span>
                      {Translations(this.state.pageJson.button_shareCase.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                    </div>
                  </button>
                }
                {!this.props.customer
                  ? <button
                    className="gdocs-btn-default gdocs-btn-wrap btn-li btn-padding"
                    onClick={this.openAddOwnerModalDialog}
                    id="add/update_Owner"
                    tabIndex="0"
                    disabled={this.props.footerBtnsStatus.addOwner.disabled}
                  >
                    {Translations(this.state.pageJson.button_addUpdate.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  </button>
                  : ''
                }
                {
                  <button
                    className="gdocs-btn-default gdocs-btn-wrap btn-li btn-padding"
                    onClick={this.redirectTopage}
                    tabIndex="0"
                    disabled={this.props.footerBtnsStatus.previewRequestBtn.disabled}
                  >
                    {Translations(this.state.pageJson.button_preview.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  </button>
                }
              </div>
              {!this.props.customer
                ? <button className="gdocs-btn-primary gdocs-btn-wrap btn-li btn-padding"
                  onClick={this.openSubmitRequestModalDialog}
                  id="_generateDocumentation"
                  tabIndex="0"
                  disabled={this.props.footerBtnsStatus.generateDocumentationBtn.disabled}
                >
                  {Translations(this.state.pageJson.button_generate.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </button>
                : <button className="gdocs-btn-primary gdocs-btn-wrap btn-li btn-padding"
                  onClick={this.openSubmitRequestModalDialog}
                  id="_generateDocumentation"
                  tabIndex="0"
                  disabled={this.props.footerBtnsStatus.generateDocumentationBtn.disabled}
                >
                  {Translations(this.state.pageJson.button_generate.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </button>
              }
            </div>
          </CaseBodyFooter>

          <CancelCaseModal
            showDialog={this.state.showCancelCaseModalDialog}
            {...this.state.cancelCaseModalPageJson.par}
            toggleDialog={this.toggleCancelCaseDialog}
            _onCancelCase={this._onCancelCase}
            _onChange={this.checkboxStatus}
            _checked={this.state.checkedvlaue}
            _setDisabled={!this.state.minNoOfCasesSelected || !this.state.cancelReasonListed}
            _setRadioSelection={this.setRadioSelection}
            _entityChecked={this.checkedOptions}
            _getCases={this.props.cases}
            _checkedOption={this.state.checkedOptionvalue}
            _cancelReason={this.state.cancelReason}
            bsClass="gdocs-cancel-request-modal-content"
            lang={this.props.lang}
          />

          <SendToClientModal
            showDialog={this.state.openSendToClientModalDialog}
            formJsonClientToSend={this.state.formJsonClientToSend}
            toggleDialog={() => this.toggleDialog("_shareCase")}
            _sentToClientChecked={this.sentToClientCheckedOptions}
            _showCheck={this.state.minNoOfClientCasesSelected}
            _resetStateVals={this.state.resetStateVals}
            history={this.props.history}
            customer={this.props.customer}
            cases={this.props.cases}
            getFormDataClientToSend={this.getFormDataClientToSend}
            onFormSubmitClientToSend={this.onFormSubmitClientToSend}
            onFormCancelClientToSend={this.onFormCancelClientToSend}
            bsClass="send-to-client-modal-content"
            lang={this.props.lang}
          />

          <ShareCaseConfirmation
            showDialog={this.state.openSendToClientModalConfirmationDialog}
            formJsonInviteSent={this.state.formJsonInviteSent}
            toggleDialog={this.toggleDialog}
            history={this.props.history}
            customer={this.props.customer}
            getFormDataClientToSend={this.getFormDataClientToSend}
            bsClass="send-to-client-modal-content"
            lang={this.props.lang}
          />

          <AddOwnerModal
            showDialog={this.state.openAddOwnerModalDialog}
            toggleDialog={this.toggleDialog}
            history={this.props.history}
            customer={this.props.customer}
            _getSelectedUser={this.getSelectedUser}
            _displaySelectedUser={this.state.displaySelectedUser}
            primaryOwner={this.state.userRoll !== undefined ? this.state.userRoll : ''}
            setListData={this.state.displayUserData}
            _setOwnerRoll={this.setOwnerRoll}
            bsClass="send-to-client-modal-content"
            lang={this.props.lang}
            formJsonAddOwner={this.state.formJsonAddOwner}
            _submitOwner={this.submitOwner}
            _deleteAddedOwner={this.deleteAddedOwner}
            primaryOwnerText={this.translateWordForRadio(this.state.formJsonAddOwner.par.guideradiobutton_assignRole.options)[0].split('=')[1]}
            secondaryOwnerText={this.translateWordForRadio(this.state.formJsonAddOwner.par.guideradiobutton_assignRole.options)[1].split('=')[1]}
          />

          <SubmitRequestModal
            showDialog={this.state.showSubmitRequestModalDialog}
            {...this.state.productRequestJson}
            toggleDialog={() => this.toggleDialog("_generateDocumentation")}
            cases={this.props.cases || []}
            generateDoc={this.props.generateDoc || []}
            _caseSelectedMultiEntity={this._caseSelectedForDraftMultiEntity}
            _caseSelectedSingleEntity={this._caseSelectedForDraftSingleEntity}
            _onGenerateDraftClick={this._onGenerateDraftClick}
            _onOk={this._onOk}
            _enableGenerateDraftBtn={this.state.caseIdsForDraftGeneration}
            bsClass="submit-request-modal-content"
            _productDetails={this.props.productDetails}
            lang={this.props.lang}
            _selectAllCaseSelectedForDraftMultiEntity={this._selectAllCaseSelectedForDraftMultiEntity}
            selectAllFlag={this.state.selectAllFlag}
            showUserPathSelection={this.state.showUserPathSelection || false}
            forceGDocsPath={this.state.forceGDocsPath}
            handlePathSelectionRadioOnChange={this.handlePathSelectionRadioOnChange}
            isTbtEnabled={this.props.isTbtEnabled}
            isTbtForceGDocsEnabled={this.props.isTbtForceGDocsEnabled}
          />

          <DraftGenerationSucessModal
            showDialog={this.state.showDraftGenerationSuccessModal}
            {...this.state.documentationConfirmationJson}
            toggleDialog={this.toggleDialog}
            _onOk={this._onOk}
            bsClass="draft-generation-ok-modal-content"
            lang={this.props.lang}
            isTbtFlow={this.state.isTbtFlow}
          />

          <GenerateBgProcessModal
            showDialog={this.state.showGenerateBgProcessModal}
            {...this.state.documentationConfirmationJson}
            {...this.state.documentationJson}
            toggleDialog={this.redirectToCaseList}
            bsClass="bg-process-modal-content"
            _onOk={this.redirectToCaseList}
            lang={this.props.lang}
          />
        </div>)
    }
    return (<div>{caseBodyJsx}</div>)
  }

  componentWillUnmount() {
    clearInterval(this.cancelDocStatusPoll);
    clearInterval(this.cancelTbtDocStatusPoll);
    this.props.resetCaseMenuInfo()
  }
}

const mapStateToProps = state => {
  return {
    cases: state.cases,
    generateDoc: state.generateDoc,
    customer: state.auth.userDetails.roleDetails.customer,
    roleDetails: state.auth.userDetails.roleDetails,
    isTbtEnabled: isTbtEnabled(state.auth.userDetails),
    isTbtForceGDocsEnabled: isTbtForceGDocsEnabled(state.auth.userDetails),
    entities: state.entities,
    tabs: state.caseBodyTabsState,
    footerBtnsStatus: state.caseBodyFooterBtnsState,
    _showPreviewAndGenerateDocBtns: state.caseBodyFooterBtnsState.showPreviewAndGenerateDocBtns,
    owningCase: electOwningCase(state.cases),
    activeTabId: state.caseBodyTabsState.activeTabId,
    productDetails: state.productDetails,
    lang: state.lang,
    token: state.auth.token
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args));
    },
    setCurrentActiveTab: (activeTabId) => {
      dispatch(setCurrentActiveTab(activeTabId));
    },
    enableTab: (tabName) => {
      dispatch(enableTab(tabName));
    },
    showPreviewAndGenerateDocBtns: () => {
      dispatch(showPreviewAndGenerateDocBtns());
    },
    hidePreviewAndGenerateDocBtns: () => {
      dispatch(hidePreviewAndGenerateDocBtns());
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
    resetStore: (lang) => {
      dispatch(resetStore(lang))
    },
    caseMenuInfo: caseMenuData => {
      dispatch(caseMenuInfo(caseMenuData))
    },
    setGenrateDoc: (generateDocdata) => {
      dispatch(setGenrateDoc(generateDocdata))
    },
    setCaseOwner: (caseOwner) => {
      dispatch(setCaseOwner(caseOwner))
    },
    resetCaseMenuInfo: () => {
      dispatch(resetCaseMenuInfo())
    },
    setCases: ({ cases, entities }) => {
      dispatch(setCases(cases, entities));
    },
  }
}

class OwnerListData {
  constructor(ownerData) {
    this.data = {};
    this.deleteData = {}
  }
  ownerPayLoad = ({ selectedUser, userRoll }) => {
    this.data.userName = selectedUser.name;
    this.data.email = selectedUser.email;
    this.data.primaryOwner = userRoll;
    this.data.psid = selectedUser.userName;
  }
  ownerDelteedPayLoad = ({ email, userName, psid }) => {
    this.deleteData.userName = userName;
    this.deleteData.email = email;
    this.deleteData.psid = psid;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Casebody);







// WEBPACK FOOTER //
// ./src/components/CaseBody/index.js